import { render, staticRenderFns } from "./ReleaseLicensesModal.vue?vue&type=template&id=630137e4&scoped=true"
import script from "./ReleaseLicensesModal.vue?vue&type=script&lang=ts"
export * from "./ReleaseLicensesModal.vue?vue&type=script&lang=ts"
import style0 from "./ReleaseLicensesModal.vue?vue&type=style&index=0&id=630137e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630137e4",
  null
  
)

export default component.exports